module.exports = __webpack_public_path__ + "static/media/google.3e7ee88b.png";